import React, { Component, PropTypes } from 'react';
import RulerBar from 'components/RulerBar';
import { mixin, RefluxMixin } from 'Util';
import { TransactionStore } from 'stores';
import AppPage from 'components/AppPage';
import { ExportActions, TransactionActions } from 'actions';
import {
  FloatingActionButton,
  ListItem,
  Styles,
  RaisedButton,
  Dialog,
  TextField
} from 'material-ui';
import Message from 'services/Message';
import ListDetail from 'components/Material/ListDetail';
import TransactionDetail from 'components/Route/Transaction/Detail';
import * as SvgIcons from 'components/Material/SvgIcons';
import { translate as _l } from 'oxygen-i18n';

const { Spacing } = Styles;

const styles = {
  filterButtonContainer: {},
  filterButton: {
    margin: 8
  }
};

/**
 * Creates a transactions overview, uses the next helpers
 * Intl         : Internationlization object
 * RefluxMixin  : Reflux helper
 * Authorizer   : Only displays this page if the user was authenticated
 * Component    : React.Component to extend
 *
 * @exports {React.Component} Transactions
 */
export default class Transactions extends mixin(RefluxMixin, Component) {
  state = {
    value: ''
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func,
  };

  handleChangeText = (e) => {
    this.setState({ value: e.target.value})
  }

  constructor() {
    super(...arguments);
    this.state = {
      filter: 'all',
      status: 2147483647
    };
  }

  setFilter = filter => {
    this.setState({ filter });
  };
  /**
   * Listen to the TransactionStore and AppStore
   *
   */
  listenToStores() {
    this.listenToStore(TransactionStore, 'transaction');
  }

  /**
   * Listen to actions and update state as needed
   */
  listenToActions() {
    this.listenToAction(TransactionActions.findByIdComplete, transaction => {
      this.setState({ selected: transaction });
    });
    this.listenToAction(
      TransactionActions.genericError,
      this.onError.bind(this)
    );
  }

  /**
   * Display error through the Message Service.
   *
   * @param  {string} errorMessage Error message to display
   */
  onError(errorMessage) {
    Message.info(errorMessage);
  }

  /**
   * Read all transactions on mount
   */
  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    TransactionActions.read();
  }

  /**
   * Select a particular transaction. This will result in the details of this transaction
   * to be displayed. If the current selected transaction is different than the already
   * selected one, also invoke an action.
   *
   * @param  {object} transaction Transaction to select
   */
  gotoTransaction(transaction) {
    if (transaction === null) {
      this.setState({ selected: null });
    } else if (!this.selected || this.selected.id !== transaction.id) {
      TransactionActions.findById(transaction.id);
    }
  }

  itemGenerator(item) {
    const refunded =
      item.status === 128
        ? ' (' + this.context.getIntlMessage('transaction.refunded') + ')'
        : '';
    const newTransaction =
      item.status === 1
        ? ' (' + this.context.getIntlMessage('transaction.new') + ')'
        : '';
    const registered =
      item.status === 4
        ? ' (' + this.context.getIntlMessage('transaction.registered') + ')'
        : '';
    const paid =
      item.status === 8 || item.status === 16
        ? ' (' + this.context.getIntlMessage('transaction.paid') + ')'
        : '';
    const error =
      item.status === 32
        ? ' (' + this.context.getIntlMessage('transaction.error') + ')'
        : '';
    const cancelled =
      item.status === 64
        ? ' (' + this.context.getIntlMessage('transaction.cancelled') + ')'
        : '';
    return (
      <ListItem
        key={'i-' + item.id}
        onTouchTap={this.gotoTransaction.bind(this, item)}
        primaryText={
          item.buyer +
          ' - ' +
          item.amount +
          ' ' +
          item.currency +
          refunded +
          newTransaction +
          registered +
          paid +
          error +
          cancelled
        }
        secondaryText={item.date.split(' ')[0]}
      />
    );
  }

  export = () => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let email = null;
    if(re.test(String(this.state.value).toLowerCase())){
      email = this.state.value;
    }
    ExportActions.exportIncomingPayment(email);
    this.refs.exportDialog.dismiss()
  }

  getFilterButtonStyle() {
    const { media } = this.context;
    const phone = media === 'phone';
    return {
      ...styles.filterButtonContainer,
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'space-around'
      // flexDirection: phone ? 'column' : 'row'
    };
  }

  renderFilterBar() {
    const { filter } = this.state;
    const { media } = this.context;
    const phone = media === 'phone';

    return (
      <div style={this.getFilterButtonStyle()}>
        <RaisedButton
          label={this.context.getIntlMessage('dashboard.filterAll')}
          backgroundColor="#ddd"
          style={styles.filterButton}
          onTouchTap={this.setFilter.bind(this, 'all')}
          disabled={filter === 'all'}
          disabledBackgroundColor="#00c9cc"
          disabledLabelColor="#ffffff"
        />
        <RaisedButton
          label={this.context.getIntlMessage('dashboard.filterPaid')}
          backgroundColor="#ddd"
          style={styles.filterButton}
          onTouchTap={this.setFilter.bind(this, 'paid')}
          disabled={filter === 'paid'}
          disabledBackgroundColor="#00c9cc"
          disabledLabelColor="#ffffff"
        />
        <RaisedButton
          label={this.context.getIntlMessage('dashboard.filterRefunded')}
          backgroundColor="#ddd"
          style={styles.filterButton}
          onTouchTap={this.setFilter.bind(this, 'refunded')}
          disabled={filter === 'refunded'}
          disabledBackgroundColor="#00c9cc"
          disabledLabelColor="#ffffff"
        />
        <RaisedButton
          label={this.context.getIntlMessage('dashboard.filterError')}
          backgroundColor="#ddd"
          style={styles.filterButton}
          onTouchTap={this.setFilter.bind(this, 'error')}
          disabled={filter === 'error'}
          disabledBackgroundColor="#00c9cc"
          disabledLabelColor="#ffffff"
        />
      </div>
    );
  }

  filterAll() {
    return true;
  }

  filterPaid(transaction) {
    return transaction.status === 8 || transaction.status === 16;
  }

  filterRefunded(transaction) {
    return transaction.status === 128;
  }

  filterCancelled(transaction) {
    return transaction.status === 64;
  }

  filterError(transaction) {
    return transaction.status === 32;
  }

  /**
   * Renders the transactions: Basically a ListDetail element with a detail element
   * if there was one selected
   *
   * @return {React.Element} Created render element
   */
  render() {
    let transactions = this.state.transaction.list;
    const loading = this.state.transactions;
    let detail;
    if (this.state.selected) {
      detail = (
        <TransactionDetail
          key={this.state.selected.id}
          transaction={this.state.selected}
          onClose={this.gotoTransaction.bind(this, null)}
        />
      );
    }

    const { filter } = this.state;
    const filtFunc = this[
      'filter' + filter.charAt(0).toUpperCase() + filter.slice(1)
    ];
    transactions = transactions.filter(filtFunc);

    let filterFunc = (item, searchText, labelProperty) => {
      if (searchText && searchText !== '') {
        return item[labelProperty].search(searchText) > -1;
      } else {
        return true;
      }
    };

    const filterBar = this.renderFilterBar();
    const exportActions = [
      { text: this.context.getIntlMessage('Cancel') },
      {
        text: this.context.getIntlMessage('Export'),
        onTouchTap: this.export,
        ref: 'submit'
      }
    ];
    return (
      <AppPage
        header={
          <RulerBar title={this.context.getIntlMessage('menu.Transactions')} />
        }
        className={'transactions'}
      >
        <ListDetail
          filter={filterFunc}
          filterBar={filterBar}
          loading={loading}
          items={transactions}
          labelProperty="buyer"
          listItemGenerator={this.itemGenerator.bind(this)}
          hasDivider={false}
          floatingActionButton={
            <FloatingActionButton onTouchTap={this.refs.exportDialog && this.refs.exportDialog.show}>
              <SvgIcons.ActionLaunch />
            </FloatingActionButton>
          }
        >
          {detail}
        </ListDetail>
        <Dialog
          ref="exportDialog"
          title={_l`customExport`}
          actions={exportActions}
          actionFocus="export"
          dismissOnClickAway={true}
        >
          <TextField
            onChange={this.handleChangeText}
            floatingLabelText=""
            hintText="Email"
          />
        </Dialog>
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Transactions.js